const handleFixChangePriceOnCart = () => {
  $(".cart-item__quantity-input").on("change", () => {
    setTimeout(() => {
      BSS_B2B.cart.fixer(
        JSON.parse($("#bss-b2b-store-data").html()),
        false,
        false
      );
      setTimeout(() => handleFixChangePriceOnCart(), 1000);
    }, 1500);
  });
  $(".quantity-up, .quantity-down").on("click", () => {
    setTimeout(() => {
      BSS_B2B.cart.fixer(
        JSON.parse($("#bss-b2b-store-data").html()),
        false,
        false
      );
      setTimeout(() => handleFixChangePriceOnCart(), 1000);
    }, 2500);
  });
};
let timeBack = 10;
const handleF = () => {
  const target = $(".cart-item__quantity-input");
  if (target.length > 0) {
    handleFixChangePriceOnCart();
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};
handleF();
